<template>
  <div class="ma-5">
    <div class="manage-department-title title-notab pb-2 pt-2">
      <img width="17" height="17" src="@/assets/icons/back-icon.png" class="mr-2" style="cursor: pointer;" @click="goBack()">
        <span class="header-title" style="font-weight: bold; font-size: 23px;">บริษัท: </span>
        <span class="header-title" style="font-weight: 400; font-size: 21px; margin-left: -10px;">{{companyName}} </span>
    </div>
    <v-row class="pt-3 pb-0">
      <v-item-group
        mandatory
        v-model="tapSelect"
        @change="page=1, getData()"
        style="width: 100%;"
        class="ma-3"
      >
          <v-row>
            <v-col cols="12" lg="3" md="3" sm="6" xs="12">
              <v-item v-slot="{ active, toggle }" >
                <v-card
                  :color="active ? '#EFF4FD' : '#F8F9FA'"
                  :class="`pa-0 ma-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="350"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7" lg="7" md="7" sm="4" xs="4">
                    <v-icon class="ml-5 mt-1" :color="active ? 'white' : '#3776E9'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#3776E9' : '#EFF4FD' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-format-list-bulleted</v-icon>
                  </v-col>
                  <v-col cols="5" lg="5" md="5" sm="8" xs="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #3776E9;">{{ allCount }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">All</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="12" lg="3" md="3" sm="6" xs="12">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#ECF8EA' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="350"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7" lg="7" md="7" sm="4" xs="4">
                    <v-icon class="ml-5 mt-1" :color="active ? 'white' : '#58A144'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#58A144' : '#ECF8EA' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-check-circle-outline</v-icon>
                  </v-col>
                  <v-col cols="5" lg="5" md="5" sm="8" xs="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #58A144;">{{ activeCount }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">Activated</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="12" lg="3" md="3" sm="6" xs="12">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#FBE5E4' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="350"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7" lg="7" md="7" sm="4" xs="4">
                    <v-icon class="ml-5 mt-1" :color="active ? 'white' : '#D1392B'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#D1392B' : '#FBE5E4' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-close-circle-outline</v-icon>
                  </v-col>
                  <v-col cols="5" lg="5" md="5" sm="8" xs="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #D1392B;">{{ inactiveCount }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">Deactivated</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <!-- #E9A016', colorback: '#FEF5E9' -->
            <v-col cols="12" lg="3" md="3" sm="6" xs="12">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#FEF5E9' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="350"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7" lg="7" md="7" sm="4" xs="4">
                    <v-icon class="ml-5 mt-1" :color="active ? 'white' : '#E9A016'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#E9A016' : '#FEF5E9' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-pencil-circle-outline</v-icon>
                  </v-col>
                  <v-col cols="5" lg="5" md="5" sm="8" xs="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #E9A016;">{{ draftCount }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">Draft</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
      </v-item-group>
    </v-row>
    <v-row class="pt-0" style="margin-top: -10px;">
    <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 pb-0">
      <span class="head-search-text">ค้นหา</span>
      <v-text-field
        v-model="keywordSearch"
        item-text="groupCompanyNameFull"
        item-value="groupCompanyId"
        multiple
        outlined
        dense
        clearable
        class="mt-2"
        placeholder="Search"
        no-data-text="ไม่พบข้อมูล"
        @change="page=1, getData()"
        @click:clear="keywordSearch='', page=1, getData()"
      >
        <template v-slot:append>
          <img width="18" height="18" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="page=1, getData()">
        </template>
      </v-text-field>
    </v-col>
    <v-col cols="auto" sm="auto" md="auto" lg="auto" class="pt-0 d-flex align-end" style="padding-bottom: 15px;">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        :nudge-top='-10'
        max-width="328"
        left
        offset-y
        origin='left'
        tile
        z-index="0"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="button-color-outline head-search-button"
            style="width: 96px; height: 38px;"
            text
            elevation="0"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left>
              mdi-filter-variant
            </v-icon>
            ตัวกรอง
          </v-btn>
        </template>
        <v-card class="pa-3">
          <v-row class="pt-3">
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">สายบังคับบัญชา</span>
              <v-autocomplete
                v-model="searchOrgId"
                :items="itemsOrgId"
                item-text="orgChart"
                item-value="orgId"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
                @click:clear="$nextTick(() => searchOrgId='')"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">สิทธิ์หลัก</span>
              <v-autocomplete
                v-model="searchID"
                :items="itemsID"
                item-text="name"
                item-value="_id"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
                @click:clear="$nextTick(() => searchID='')"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :return-value.sync="searchCreateAt"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <span class="head-search-text">วันที่สร้าง</span>
                  <v-text-field
                    class="mt-2"
                    :value="dateRangeTextCreate"
                    placeholder="ปปปป-ดด-วว ~ ปปปป-ดด-วว"
                    readonly
                    append-icon="fa-calendar-alt"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    clearable
                    @click:clear="resetCreateDate()"
                  >
                  <template v-slot:append>
                    <v-icon color="#2BA197">mdi-calendar</v-icon>
                  </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="searchCreateAt" range :max="toDay" color="#2BA197">
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    class="button-color-outline"
                    @click="menu1 = false"
                  >
                    ยกเลิก
                  </v-btn>
                  <v-btn
                    v-if="searchCreateAt[0] !== undefined && searchCreateAt[1] !== undefined"
                    text
                    class="button-color-outline"
                    @click="$refs.menu1.save(searchCreateAt)"
                  >
                    ตกลง
                  </v-btn>
                  <v-btn
                    v-else
                    text
                    color="gray"
                    disabled
                  >
                    ตกลง
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="d-flex">
            <v-spacer/>
            <v-btn
              class="button-color-outline head-search-button mr-2"
              outlined
              style="width: 60px;"
              elevation="0"
              @click="resetFilterData()"
            >ล้าง</v-btn>
            <v-btn
              class="button-color btn-search-dep ml-2 mr-3"
              style="width: 94px;"
              dark
              @click="page=1, getData()"
            >ค้นหา</v-btn>
          </v-row>
        </v-card>
      </v-menu>
    </v-col>
    <v-spacer/>
    <v-col cols="auto" style="">
      <br>
      <v-btn
        elevation="0"
        class="button-color-outline"
        outlined
        @click="goToAssignRight()"
      >
        จัดการสิทธิ์
      </v-btn>
    </v-col>
    <v-col cols="auto" style="">
      <br>
      <v-btn
        elevation="0"
        class="button-color"
        dark
        @click="goToCreate()"
      >
        <v-icon left size="14px">
          mdi-plus
        </v-icon>
        สร้างสิทธิ์
      </v-btn>
    </v-col>
  </v-row>
    <OverlayLoading :loading="loading" />
    <div>
      <v-data-table
        class="border-table-employee text-no-wrap table-approve"
        item-key="index"
        v-model="selected"
        :headers="headers"
        :items="dataTable"
        :loading="loading"
        loader-height=0
        loading-text="Loading... Please wait"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100, -1],
          'items-per-page': 15
        }"
        :server-items-length="allCount || -1"
        disable-sort
        @update:items-per-page="changePerPage"
        @update:page="changePage"
        group-by="orgChart"
        :expanded.sync="expanded"
        :page.sync="page"
        :items-per-page="perPage"
        hide-default-footer
        @page-count="pageCount = $event"
      >
        <template v-slot:[`group.header`]="{ group, headers, toggle, isOpen }">
          <td :colspan="headers.length" style="background: #FAFAFA;" onMouseLeave="this.style.background='#FAFAFA'" onMouseEnter="this.style.background='#eeeeee'">
              <v-btn @click="toggle" small icon :ref="group" :data-open="isOpen">
                  <v-icon v-if="isOpen" color="#1654C6">mdi-chevron-up</v-icon>
                  <v-icon v-else color="#1654C6">mdi-chevron-down</v-icon>
              </v-btn>
              <span class="blue--text text--darken-3 font-weight-normal">สายบังคับบัญชา : {{ group }}</span>
          </td>
        </template>
        <template v-slot:[`item.no`]="{ item }">
          {{ (perPage*(page-1)) + dataTable.indexOf(item)+1 }}
        </template>
        <template v-slot:[`item.totalSubRight`]="{ item }">
          <a style="text-decoration: underline;" @click="showSubRight(item)">{{item.totalSubRight}}</a>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-tooltip
            bottom
            v-if="item.status === 'activated' || item.status === 'deactivated'"
          >
            <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
              style="margin-top: -20px; margin-bottom: -20px; height: 48px;"
            >
              <v-switch
                v-model="item.status"
                :value="item.status !== 'activated'"
                class=""
                style="transform: scale(0.9); margin-left: auto;"
                color="#2BA197"
                flat
                inset
                dense
                readonly
                @click="dialogConfirmChangeStatus = true, onFocusItem = item"
              ></v-switch>
            </div>
          </template>
            <span class="label-table-action">เปิด/ปิด การใช้งาน</span>
          </v-tooltip>
          <v-chip
            v-else
            :color="'#ECF9FF'"
            :text-color="'#3776E9'"
            small
            class="pl-2 pr-2"
          >
            <span>{{ item.status || '-' }}</span>
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                icon
                tile
                small
                class="ra-border-button mr-1 ml-0"
                @click="edit(item)"
              >
              <v-icon dark color="#2BA197" small>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">แก้ไขข้อมูล</span>
          </v-tooltip>
          <v-tooltip bottom v-if="item.orgId">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                icon
                tile
                small
                class="ra-border-button mr-1 ml-1"
                @click="editAssign(item)"
              >
              <v-icon dark color="primary" small>mdi-account-edit-outline</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">แก้ไขจัดการสิทธิ์</span>
          </v-tooltip>
          <v-tooltip bottom v-if="item.orgId">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                color="#FFB300"
                dark
                icon
                small
                class="ra-border-button mr-0 ml-1"
                @click="dialogConfirmRemoveAssign = true, onFocusItem = item"
              >
              <v-icon color="error" small>mdi-account-off-outline</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">ลบจัดการสิทธิ์</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                color="#FFB300"
                dark
                icon
                small
                class="ra-border-button mr-0 ml-1"
                @click="dialogConfirmRemove = true, onFocusItem = item"
              >
              <v-icon color="error" small>mdi-delete-outline</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">ลบข้อมูล</span>
          </v-tooltip>
          <!-- <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn> -->
        </template>
      </v-data-table>
      <v-row>
      <v-col cols="12" class="pa-0">
      <div class="justify-end d-flex align-end pt-4">
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination>
      </div>
      </v-col>
    </v-row>
    </div>
    <v-dialog v-model="dialogConfirmRemove" max-width="344px" persistent>
    <v-card >
      <v-card-title class="ra-head-text-bold justify-center pa-5">
        ต้องการลบสิทธิ์ใช่ไหม
      </v-card-title>
      <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center" style="font-size: 16px;">
          คุณแน่ใจหรือไม่ว่าต้องการลบสิทธินี้<br>และสิทธิที่มีความสัมพันธ์กันถัดลงไป<br>จะถูกลบไปด้วย
        </span>
      </v-card-text>
      <v-card-actions class="justify-center mt-0 pb-5">
          <v-btn
            color="primary"
            outlined
            class="head-search-button mr-4"
            width="100"
            @click="dialogConfirmRemove = false"
          >
          ยกเลิก
          </v-btn>
          <v-btn
            color="primary"
            class="head-search-button ml-4 white--text text--lighten-4"
            elevation="0"
            width="100"
            @click="clickRemove(onFocusItem), dialogConfirmRemove = false"
          >
          ลบข้อมูล
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialogConfirmRemoveAssign" max-width="344px" persistent>
    <v-card >
      <v-card-title class="ra-head-text-bold justify-center pa-5">
        ต้องการลบจัดการสิทธิใช่ไหม
      </v-card-title>
      <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center" style="font-size: 16px;">
          คุณแน่ใจหรือไม่ว่าต้องการลบจัดการสิทธินี้
        </span>
      </v-card-text>
      <v-card-actions class="justify-center mt-0 pb-5">
          <v-btn
            color="primary"
            outlined
            class="head-search-button mr-4"
            width="110"
            @click="dialogConfirmRemoveAssign = false"
          >
          ยกเลิก
          </v-btn>
          <v-btn
            color="primary"
            class="head-search-button ml-4 white--text text--lighten-4"
            elevation="0"
            width="110"
            @click="clickRemoveAssign(onFocusItem), dialogConfirmRemoveAssign = false"
          >
          ลบจัดการสิทธิ์
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialogConfirmChangeStatus" max-width="380px" persistent>
    <v-card >
      <v-card-title class="ra-head-text-bold justify-center pa-5">
        ต้องการ{{onFocusItem.status == 'activated' ? 'ปิด':'เปิด'}}การใช้งานสิทธ์ใช่ไหม
      </v-card-title>
      <v-card-text class="justify-center text-center">
      <span class="ra-head-text justify-center" style="font-size: 16px;">คุณแน่ใจหรือไม่ว่าต้อง{{onFocusItem.status == 'activated' ? 'ปิด':'เปิด'}}การใช้งานสิทธ์นี้</span>
      </v-card-text>
      <v-card-actions class="justify-center mt-0 pb-5">
          <v-btn
            color="primary"
            outlined
            class="head-search-button mr-4"
            width="100"
            @click="dialogConfirmChangeStatus = false"
          >
          ยกเลิก
          </v-btn>
          <v-btn
            color="primary"
            class="head-search-button ml-4 white--text text--lighten-4"
            elevation="0"
            width="100"
            @click="toggleStatus(onFocusItem), dialogConfirmChangeStatus = false"
          >
          ยืนยัน
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <DialogShowSub
    :isShow="dialogShowSub"
    :data="onFocusItem"
    :companyId="companyID"
    :orgId="onFocusItem.orgId"
    :companyName="companyName"
    @closeDialogShowSub="dialogShowSub=false"
  ></DialogShowSub>
  <v-snackbar
    v-model="snackbar"
    :timeout="2000"
    top
    centered
    elevation="1"
    color="#ECF8EA"
    app
  >
    <v-icon dark color="#58A144" >mdi-check-circle-outline</v-icon>
    <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #58A144;">
      {{ snackbarText }}
    </span>
  </v-snackbar>
  </div>
</template>

<script>
import OverlayLoading from '../_template/OverlayLoading.vue'
import DialogShowSub from './_dialog/dialogShowSub'
import swal from 'sweetalert'
const axios = require('axios')
const moment = require('moment')

export default {
  components: {
    OverlayLoading,
    DialogShowSub
  },
  data () {
    return {
      toDay: new Date().toISOString(),
      apiServer: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}`,
      loading: false,
      ciphertext: '',
      companyID: '',
      companyName: '',
      groupID: '',
      tapSelect: 0,
      selected: [],
      companyDetail: {},
      dataTable: [],
      expanded: [],
      headers: [
        {
          text: 'ลำดับ',
          align: 'left',
          value: 'no',
          width: '100px',
          groupable: false,
          sortable: false
        },
        { text: 'สิทธิ์หลัก', value: 'name' },
        { text: 'จำนวนสิทธิ์ย่อย', value: 'totalSubRight' },
        { text: 'สร้างโดย', value: 'createBy' },
        { text: 'เวลาสร้าง', value: 'createAt' },
        { text: 'Activated', value: 'status', align: 'left' },
        { text: 'จัดการ', align: 'center', width: 'auto', value: 'actions', sortable: false }
      ],
      footerProps: { 'items-per-page-options': [15, 30, 50, 100, -1] },
      total: -1,
      statusList: [
        { status: 'pending', statusTH: 'กำลังดำเนินการ', color: '#00B0FF', colorback: '#ECF9FF' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144', colorback: '#ECF8EA' },
        { status: 'waiting', statusTH: 'รออนุมัติ', color: '#E9A016', colorback: '#FEF5E9' },
        { status: 'waiting', statusTH: 'รอรับทราบ', color: '#E9A016', colorback: '#FEF5E9' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B', colorback: '#FBE5E4' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#999999', colorback: '#EEEEEE' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144', colorback: '#ECF8EA' }
      ],
      tapData: ['', 'activated', 'Deactivated', 'draft'],
      allCount: 0,
      draftCount: 0,
      activeCount: 0,
      inactiveCount: 0,
      itemsOrgId: '',
      itemsID: '',
      itemsStatus: '',
      itemsCreateAt: '',
      searchOrgId: '',
      searchID: '',
      searchStatus: '',
      searchCreateAt: [],
      keywordSearch: '',
      page: 1,
      perPage: 15,
      pageCount: 0,
      onFocusItem: {},
      dialogShowSub: false,
      dialogConfirmChangeStatus: false,
      dialogConfirmRemove: false,
      dialogConfirmRemoveAssign: false,
      menu: false,
      menu1: false,
      datesCreateAt: [],
      snackbarText: '',
      snackbar: ''
    }
  },
  beforeDestroy () {
  },
  mounted () {
  },
  computed: {
    dateRangeTextCreate () {
      const chkDate = ''
      if (this.searchCreateAt.length !== 0) {
        return this.searchCreateAt.join(' ~ ')
      } else {
        return chkDate
      }
    }
  },
  watch: {
    // createDate: function (val) {
    //   if (this.createDate[0] !== undefined && this.createDate[1] !== undefined) {
    //     this.createAt = this.createDate[0] + ' ' + this.createDate[1]
    //   }
    // }
  },
  async created () {
    this.ciphertext = this.$route.params.id
    await this.decryptID(this.ciphertext)
    await this.getData()
  },
  methods: {
    goBack () {
      this.$router.push('/manageroleapprover')
    },
    async goToCreate () {
      var params = await this.encodeForCreatePage()
      this.$router.push('/manageroleapprover/create/' + params)
    },
    async goToAssignRight () {
      var params = await this.encodeForCreateAssign()
      this.$router.push('/manageroleapprover/assign/' + params)
    },
    async decryptID (id) {
      const cleanData = JSON.parse(atob(id))
      this.companyID = cleanData.companyid
      this.groupID = cleanData.groupid
    },
    changePerPage (value) {
      this.perPage = value
      this.setFilter(this.filterData)
    },
    changePage (value) {
      this.page = value
      this.setFilter(this.filterData)
    },
    async setFilter (value) {
      await this.getData()
    },
    setObjFilter (data) {
      return (typeof data === 'string') ? [data] : data
    },
    resetFilterData () {
      this.searchOrgId = ''
      this.searchID = ''
      this.searchCreateAt = []
      this.page = 1
      this.getData()
    },
    async getData () {
      // console.log(this.searchOrgId)
      this.loading = true
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/right`,
          method: 'POST',
          headers: {
            authorization: this.$store.state.token
          },
          data: {
            id: this.companyID,
            filter: {
              search: this.keywordSearch,
              orgId: this.searchOrgId,
              _id: this.searchID,
              status: this.tapData[this.tapSelect].toString().toLowerCase(),
              createAt: (this.searchCreateAt === [] || this.searchCreateAt.length === 0) ? '' : this.searchCreateAt
            },
            page: this.page,
            limit: this.perPage
          }
        })
          .then((response) => {
            if (response.data.success === true) {
              this.itemsOrgId = response.data.selector.department || []
              this.itemsID = response.data.selector.rights || []
              this.itemsStatus = response.data.selector.status || []
              this.dataTable = response.data.result
              this.allCount = response.data.allCount || 0
              this.draftCount = response.data.draftCount || 0
              this.activeCount = response.data.activeCount || 0
              this.inactiveCount = response.data.inactiveCount || 0
              this.companyName = response.data.companyName.companyFullNameTh
              this.computeData(this.dataTable)
            } else {
              this.itemsOrgId = []
              this.itemsID = []
              this.itemsStatus = []
              this.dataTable = []
              this.allCount = 0
              this.draftCount = 0
              this.activeCount = 0
              this.inactiveCount = 0
              this.companyName = ''
            }
          })
          .catch(function (thrown) {
          })
      } catch (error) { } finally {
        this.loading = false
      }
    },
    async computeData (item) {
      const haveOrg = item.filter(e => e.orgId)
      const notHaveOrg = item.filter(e => e.orgId === null)
      let newItem = await haveOrg.sort(function (a, b) {
        return (a.manageUpdateAt < b.manageUpdateAt) ? 1 : ((a.manageUpdateAt > b.manageUpdateAt) ? -1 : 0)
      })
      newItem = [...newItem, ...notHaveOrg]
      await newItem.map((itm, index) => {
        itm.index = index
      })
      await newItem.map(e => {
        e.createAt = moment(e.createAt).format('DD/MM/YYYY HH:mm น.')
        e.showIndex = newItem.indexOf(e) + 1
        // if (e.orgChart === 'ยังไม่กำหนด') e.orgChart = 'none'
      })
    },
    async sortResults (items, prop, asc) {
      items.sort(function (a, b) {
        if (asc) {
          return (a[prop] > b[prop]) ? 1 : ((a[prop] < b[prop]) ? -1 : 0)
        } else {
          return (b[prop] > a[prop]) ? 1 : ((b[prop] < a[prop]) ? -1 : 0)
        }
      })
    },
    async getCompanyImage (companyImage) {
      if (companyImage !== '') {
        return `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/companys/getcompanyFileById/` + companyImage
      }
    },
    createRoleApprover () {
    },
    showSubRight (item) {
      // console.log('showSubRight', item)
      this.onFocusItem = item
      this.dialogShowSub = true
    },
    resetCreateDate () {
      this.searchCreateAt = ''
      this.datesCreateAt = []
      this.page = 1
      this.getData()
    },
    async encodeForCreatePage () {
      var params = btoa(JSON.stringify({ backParam: this.ciphertext, groupid: this.groupID, companyid: this.companyID }))
      return params
    },
    async encodeForEditPage (data) {
      var params = btoa(JSON.stringify({ backParam: this.ciphertext, id: data, groupid: this.groupID, companyid: this.companyID }))
      return params
    },
    async encodeForCreateAssign () {
      var params = btoa(JSON.stringify({ backParam: this.ciphertext, groupid: this.groupID, companyid: this.companyID, action: 'create' }))
      return params
    },
    async encodeForEditAssign (data) {
      var params = btoa(JSON.stringify({ backParam: this.ciphertext, id: data._id, groupid: this.groupID, companyid: this.companyID, orgId: data.orgId, manageId: data.manageId, action: 'edit' }))
      return params
    },
    async edit (item) {
      // console.log('edit', item)
      const params = await this.encodeForEditPage(item._id)
      this.$router.push('/manageroleapprover/update/' + params)
    },
    async editAssign (item) {
      // console.log('editAssign', item)
      const params = await this.encodeForEditAssign(item)
      this.$router.push('/manageroleapprover/assign/' + params)
    },
    async clickRemove (item) {
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/right/${item._id}`,
          method: 'DELETE',
          headers: {
            authorization: this.$store.state.token
          }
        })
          .then((response) => {
            if (response.data.success === true) {
              this.snackbarActive('คุณได้ทำการลบข้อมูลเรียบร้อยแล้ว')
            } else {
              swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
                button: false,
                timer: 3000
              })
            }
          })
          .catch(function (thrown) {
          })
      } catch (error) { } finally {
        this.loading = false
        await this.getData()
      }
    },
    async clickRemoveAssign (item) {
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/right/deleteRelation`,
          method: 'POST',
          headers: {
            authorization: this.$store.state.token
          },
          data: {
            manageId: item.manageId
          }
        })
          .then((response) => {
            if (response.data.success === true) {
              this.snackbarActive('คุณได้ทำการลบจัดการสิทธิ์เรียบร้อยแล้ว')
            } else {
              swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
                button: false,
                timer: 3000
              })
            }
          })
          .catch(function (thrown) {
          })
      } catch (error) { } finally {
        this.loading = false
        await this.getData()
      }
    },
    snackbarActive (text) {
      this.snackbarText = text
      this.snackbar = true
    },
    async toggleStatus (item) {
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/right/status`,
          method: 'POST',
          headers: {
            authorization: this.$store.state.token
          },
          data: {
            companyId: this.companyID,
            mainId: item._id,
            status: item.status === 'activated' ? 'deactivated' : 'activated',
            orgId: item.orgId
          }
        })
          .then((response) => {
            if (response.data.success === true) {
              this.snackbarActive(item.status === 'activated' ? 'คุณได้ทำการปิดการใช้งานสิทธ์เรียบร้อยแล้ว' : 'คุณได้ทำการเปิดการใช้งานสิทธ์เรียบร้อยแล้ว')
            } else {
              swal('ผิดพลาด', 'เปลี่ยนสถานะไม่สำเร็จ กรุณาลองใหม่อีกครั้ง', 'error', {
                button: false,
                timer: 3000
              })
            }
          })
          .catch(function (thrown) {
          })
      } catch (error) { } finally {
        this.loading = false
        await this.getData()
      }
    }
  }
}
</script>

<style>
/* table */
.theme--light.v-pagination .v-pagination__item--active {
    background: #2BA197 !important;
    color: #FFFFFF;
}
.v-pagination__item {
    background: transparent;
    border-radius: 4px;
    font-size: 14px;
    height: 30px;
    margin: 0.3rem;
    min-width: 30px;
    padding: 0 5px;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: auto;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
.v-pagination__navigation {
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    height: 30px;
    width: 30px;
    margin: 0.3rem 10px;
}
/* end */
.role-approve-main >>> .disable-events {
    pointer-events: none
  }

 .role-approve-main >>>  .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn-outlined) {
  color: fuchsia !important;
}

/* .group-header {
  background: #FAFAFA;
}
.group-header:hover {
  background: yellow;
} */

/* .theme--light.v-data-table .v-row-group__header, .theme--light.v-data-table .v-row-group__summary {
  background:red;
} */
</style>
